import React from 'react';

export function List({ children }: { children: React.ReactNode }) {
	return <ul className="list-disc space-y-1.5 py-2 pl-8 pr-3 marker:text-gray-400">{children}</ul>;
}

function ListItem({ children }: { children: React.ReactNode }) {
	return <li className="group/iv rounded-md border border-transparent py-1.5 pl-1 pr-2">{children}</li>;
}

List.ListItem = ListItem;
